import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Loader from '../../common/components/Loader';
import {
    Alert,
    Box,
    Button,
    Container,
    Paper,
    Stack,
    TextField,
    Tooltip,
    Typography,
} from '@mui/material';
import { ProfileService } from './Services/ProfileService';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function UpdatePassword() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const profileService = new ProfileService();
    const [formData, setFormData] = useState({
        currentPassword: '',
        newPassword: '',
        confirmedNewPassword: '',
    });
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const handleSave = async () => {
        setIsLoading(true);
        setErrorMessage(null);
        const result = await profileService.updatePassword(
            formData.currentPassword,
            formData.newPassword,
            formData.confirmedNewPassword
        );
        setIsLoading(false);
        if (result.success) {
            navigate('..');
        } else {
            setErrorMessage(result.error);
        }
    };

    const handleCancel = () => {
        navigate('..');
    };

    if (isLoading) {
        return <Loader />;
    }

    return (
        <Container maxWidth="sm">
            <Box display="flex" alignItems="center" mb={2}>
                <Button
                    startIcon={<ArrowBackIcon />}
                    onClick={handleCancel}
                    color="primary"
                >
                    Tillbaka
                </Button>
            </Box>
            <Paper elevation={3} className="p-8 border-r-6">
                <Typography variant="h4" align="center" gutterBottom>
                    Byt lösenord
                </Typography>
                <Box mt={2} mb={2} borderBottom={1} borderColor="divider" />

                {errorMessage && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {errorMessage}
                    </Alert>
                )}

                <Stack spacing={2}>
                    <TextField
                        label="Nuvarande Lösenord"
                        variant="outlined"
                        type="password"
                        fullWidth
                        autoComplete="off"
                        value={formData.currentPassword}
                        onChange={(e) =>
                            setFormData({
                                ...formData,
                                currentPassword: e.target.value,
                            })
                        }
                    />
                    <Tooltip
                        title="Lösenordet behöver innehålla minst 6 tecken och innehålla en siffra, en liten bokstav och en stor bokstav."
                        placement="top-end"
                    >
                        <TextField
                            label="Nytt Lösenord"
                            variant="outlined"
                            type="password"
                            fullWidth
                            autoComplete="off"
                            value={formData.newPassword}
                            onChange={(e) =>
                                setFormData({
                                    ...formData,
                                    newPassword: e.target.value,
                                })
                            }
                        />
                    </Tooltip>
                    <Tooltip
                        title="Lösenordet behöver innehålla minst 6 tecken och innehålla en siffra, en liten bokstav och en stor bokstav."
                        placement="top-end"
                    >
                        <TextField
                            label="Bekräfta Lösenord"
                            variant="outlined"
                            type="password"
                            fullWidth
                            autoComplete="off"
                            value={formData.confirmedNewPassword}
                            onChange={(e) =>
                                setFormData({
                                    ...formData,
                                    confirmedNewPassword: e.target.value,
                                })
                            }
                        />
                    </Tooltip>
                </Stack>

                <Stack
                    direction="row"
                    spacing={2}
                    justifyContent="center"
                    mt={3}
                >
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={handleCancel}
                        sx={{ minWidth: '120px' }}
                    >
                        Avbryt
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSave}
                        sx={{ minWidth: '120px' }}
                    >
                        Spara
                    </Button>
                </Stack>
            </Paper>
        </Container>
    );
}
